/* PE Menu v6 - v60: saiu do layout/theme.liquid para ficheiro (fica em cache). Carregado com defer no <head>, antes dos outros scripts do tema. */
(function(){
    var O='on';
    /* backdrop */
    var bd=document.createElement('div');
    bd.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.44);z-index:849;opacity:0;pointer-events:none;transition:opacity .22s;cursor:pointer';
    document.body.appendChild(bd);
    bd.addEventListener('click',closeAll);
    function showBd(){bd.style.opacity='1';bd.style.pointerEvents='all';}
    function hideBd(){bd.style.opacity='0';bd.style.pointerEvents='none';}

    /* v30 Fase 1G: ao abrir o cesto o foco vai para o botao fechar; ao fechar volta ao botao que o abriu */
    var peLastFocus=null,peLastFocusFb=false;
    function closeAll(){
      var peWasOpen=['cartDrawer','mobileNav','searchPanel'].some(function(id){var el=document.getElementById(id);return el&&(el.classList.contains(O)||el.classList.contains('open'));});
      ['cartDrawer','mobileNav','searchPanel'].forEach(function(id){
        var el=document.getElementById(id);
        if(el){el.classList.remove(O,'open');el.setAttribute('aria-hidden','true');}
      });
      /* Defensive: clean up the static #cartOverlay element too, in case
         anything ever sets it again -- this is what got left stuck dark
         and unclickable after closing the cart in the reported bug. */
      var staticOverlay=document.getElementById('cartOverlay');
      if(staticOverlay) staticOverlay.classList.remove('on');
      var b=document.getElementById('burgerBtn');
      if(b)b.setAttribute('aria-expanded','false');
      hideBd();document.body.style.overflow='';
      document.querySelectorAll('.mega.open').forEach(function(m){m.classList.remove('open');});
      var lf=peLastFocus,fb=peLastFocusFb;peLastFocus=null;peLastFocusFb=false;
      /* v30 Fase 1P: se o botao de origem ja nao existir ou estiver escondido/desativado, o foco vai para o botao do cesto visivel */
      if(peWasOpen&&lf&&fb&&!(document.body.contains(lf)&&!lf.disabled&&lf.getClientRects().length)){lf=null;['#cartBtn','.pe-tab--cart'].some(function(s){var c=document.querySelector(s);if(c&&c.getClientRects().length){lf=c;return true;}return false;});}
      if(peWasOpen&&lf&&lf.focus&&document.body.contains(lf)){try{lf.focus({preventScroll:true});}catch(e){}}
    }

    function openPanel(id,ret){
      /* v30 Fase 1P: quem abre pode indicar para onde o foco volta (ret) - o botao "Adicionar ao cesto" fica
         desativado durante o pedido e o foco caia no body, por isso nao havia para onde voltar */
      var opener=(ret&&ret.nodeType===1)?ret:document.activeElement;
      closeAll();
      var el=document.getElementById(id);if(!el)return;
      el.classList.add(O);el.setAttribute('aria-hidden','false');
      showBd();document.body.style.overflow='hidden';
      peLastFocus=(opener&&opener!==document.body)?opener:null;
      peLastFocusFb=!!(ret&&ret.nodeType===1);
      if(id==='cartDrawer'){setTimeout(function(){var c=document.getElementById('cartClose');if(c&&el.classList.contains(O)){try{c.focus({preventScroll:true});}catch(e){}}},80);}
    }

    function openCart(ret){
      openPanel('cartDrawer',ret);
      if(window.cartGet&&window.renderCart)window.cartGet(window.renderCart);
    }
    function openMobile(){
      openPanel('mobileNav');
      var b=document.getElementById('burgerBtn');
      if(b)b.setAttribute('aria-expanded','true');
      /* v30 Fase 1J: o foco entra no menu (botao fechar), como no cesto */
      setTimeout(function(){var mn=document.getElementById('mobileNav'),c=document.getElementById('mnClose');if(mn&&c&&mn.classList.contains(O)){try{c.focus({preventScroll:true});}catch(e){}}},80);
    }
    function openSearch(){
      openPanel('searchPanel');
      setTimeout(function(){
        var i=document.getElementById('searchInput')||document.querySelector('.search-inp');
        if(i)i.focus();
      },60);
    }

    /* Click delegation */
    document.addEventListener('click',function(e){
      var t=e.target;if(!t)return;
      if(t.closest&&t.closest('#cartBtn')){openCart();return;}
      if(t.closest&&(t.closest('#cartClose')||t.closest('#cdContinue')||t.closest('.cd-empty-btn')||t.closest('[data-pe-close-cart]'))){closeAll();return;}
      if(t.closest&&t.closest('#burgerBtn')){
        var mn=document.getElementById('mobileNav');
        (mn&&mn.classList.contains(O))?closeAll():openMobile();return;
      }
      if(t.closest&&t.closest('#mnClose')){closeAll();return;}
      if(t.closest&&t.closest('#searchBtn')){
        var sp=document.getElementById('searchPanel');
        (sp&&sp.classList.contains(O))?closeAll():openSearch();return;
      }
      if(t.closest&&t.closest('#searchClose')){closeAll();return;}
    });
    document.addEventListener('keydown',function(e){if(e.key==='Escape')closeAll();});

    /* v30 Fase 1J: paineis fechados (menu movel, pesquisa) ficam fora do Tab e dos leitores de ecra (inert).
       Estavam so fora do ecra - o Tab entrava em 26 links invisiveis. Segue a classe de aberto, seja qual for o script que a muda. */
    ['mobileNav','searchPanel','cartDrawer','wlDrawer'].forEach(function(id){
      var el=document.getElementById(id);if(!el)return;
      var sync=function(){var on=el.classList.contains(O)||el.classList.contains('open');if(on){el.removeAttribute('inert');}else{el.setAttribute('inert','');}};
      sync();
      if(window.MutationObserver)new MutationObserver(sync).observe(el,{attributes:true,attributeFilter:['class']});
    });

    /* v30 Fase 1J: com o menu, o cesto, os favoritos ou os filtros abertos, Tab e Shift+Tab ficam dentro do painel */
    var peTraps=[['mobileNav',O],['cartDrawer',O],['wlDrawer','open'],['pfd','on'],['galLightbox','open']]; /* v30 Fase 1O: + ampliacao das fotos da ficha */
    var peFocSel='a[href],button:not([disabled]),summary,input:not([disabled]):not([type=hidden]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
    function peFocusables(root){
      return Array.prototype.filter.call(root.querySelectorAll(peFocSel),function(n){
        if(n.closest('[inert]'))return false;
        var dt=n.closest('details');if(dt&&!dt.open&&n.tagName!=='SUMMARY')return false;
        if(!n.getClientRects().length)return false;
        return getComputedStyle(n).visibility!=='hidden';
      });
    }
    document.addEventListener('keydown',function(e){
      if(e.key!=='Tab')return;
      var root=null;
      for(var i=0;i<peTraps.length;i++){var el=document.getElementById(peTraps[i][0]);if(el&&el.classList.contains(peTraps[i][1])){root=el;break;}}
      if(!root)return;
      var list=peFocusables(root);
      /* o aviso "Anular" de um artigo removido do cesto fica fora da gaveta, mas tem de se alcancar */
      if(root.id==='cartDrawer'){var ut=document.getElementById('peUndoToast');if(ut)list=list.concat(peFocusables(ut));}
      if(!list.length){e.preventDefault();return;}
      var a=document.activeElement,first=list[0],last=list[list.length-1],inside=root.contains(a)||list.indexOf(a)>-1;
      if(e.shiftKey){if(a===first||!inside){e.preventDefault();last.focus();}}
      else{if(a===last||!inside){e.preventDefault();first.focus();}}
    });

    /* v30 Fase 1J: link da pagina atual no menu marcado com aria-current (so leitura do URL, sem mudar links) */
    (function(){
      var here=location.pathname.replace(/\/$/,'')||'/';
      document.querySelectorAll('.hdr-nav a[href], #mobileNav a[href]').forEach(function(a){
        var h=a.getAttribute('href');if(!h||h.charAt(0)!=='/'||h.indexOf('?')>-1)return; /* links com filtros (?filter...) nao sao a pagina atual */
        var hp=h.split('?')[0].split('#')[0].replace(/\/$/,'')||'/';
        if(hp===here&&hp!=='/'&&!a.hasAttribute('aria-current'))a.setAttribute('aria-current','page'); /* nao mexe no que o pe-nav.liquid ja marca */
      });
    })();

    /* v30 Fase 1J: os contadores do cesto e dos favoritos passam a fazer parte do nome do botao ("Cesto (2)").
       Nao e regiao viva - nao anuncia a cada mudanca, so quando o botao e lido. */
    function peCountLabels(){
      [['#cartBtn','.cart-pill'],['#wishlistBtn','#wlBadge'],['.pe-tab--cart','.pe-tab-badge'],['.pe-tab--wl','.pe-tab-badge']].forEach(function(pair){
        var btn=document.querySelector(pair[0]);if(!btn||btn.dataset.peCnt)return;
        var badge=btn.querySelector(pair[1]);if(!badge)return;
        btn.dataset.peCnt='1';
        var base=btn.getAttribute('aria-label')||'';
        var upd=function(){var n=parseInt(badge.textContent,10);btn.setAttribute('aria-label',n>0?base+' ('+n+')':base);}; /* v30 Fase 1K: so o numero conta - os favoritos mostram o contador por classe, nao por style */
        upd();
        if(window.MutationObserver)new MutationObserver(upd).observe(badge,{childList:true,characterData:true,subtree:true,attributes:true,attributeFilter:['style','class']});
      });
    }
    if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',peCountLabels);}else{peCountLabels();}
    window.addEventListener('load',peCountLabels);

    /* -- Mega menu -- robust hover intent -- */
    (function(){
      var cm=null, ot=null, ct=null;
      var OPEN_MS=60, CLOSE_MS=600;

      function openMega(mega){
        clearTimeout(ct); clearTimeout(ot);
        ot=setTimeout(function(){
          if(cm && cm!==mega) cm.classList.remove('open');
          mega.classList.add('open'); cm=mega;
        }, OPEN_MS);
      }
      function schedulClose(){
        clearTimeout(ot);
        ct=setTimeout(function(){
          if(cm){ cm.classList.remove('open'); cm=null; }
        }, CLOSE_MS);
      }
      function isOverHeader(){
        var h=document.querySelector('.site-header');
        if(!h) return false;
        var r=h.getBoundingClientRect();
        return (lastX>=r.left&&lastX<=r.right&&lastY>=r.top&&lastY<=r.bottom);
      }
      var lastX=0,lastY=0;
      document.addEventListener('mousemove',function(e){lastX=e.clientX;lastY=e.clientY;},{passive:true});

      document.querySelectorAll('.nav-item').forEach(function(item){
        var mega=item.querySelector('.mega'); if(!mega) return;
        /* Open on nav button hover */
        item.addEventListener('mouseenter', function(){ openMega(mega); });
        /* Cancel close when inside mega */
        mega.addEventListener('mouseenter', function(){ clearTimeout(ct); clearTimeout(ot); });
        mega.addEventListener('mouseleave', schedulClose);
        /* Only close nav-item if cursor is NOT heading into the mega */
        item.addEventListener('mouseleave', function(e){
          /* relatedTarget = element cursor is moving TO */
          var to = e.relatedTarget;
          /* If heading into the mega itself, cancel close */
          if(mega.contains(to) || to===mega){ clearTimeout(ot); return; }
          schedulClose();
        });
      });

      /* Close on click outside header */
      document.addEventListener('click', function(e){
        if(!e.target.closest('.site-header') && cm){
          cm.classList.remove('open'); cm=null;
        }
      });
      /* Close on Escape */
      document.addEventListener('keydown', function(e){
        if(e.key==='Escape' && cm){ cm.classList.remove('open'); cm=null; }
      });
    })();

    /* Mobile nav tabs */
    document.querySelectorAll('.mn-tab').forEach(function(btn){
      btn.addEventListener('click',function(){
        var tab=btn.dataset.tab;
        document.querySelectorAll('.mn-tab').forEach(function(b){b.classList.remove('active');});
        document.querySelectorAll('.mn-panel').forEach(function(p){p.classList.remove('active');});
        btn.classList.add('active');
        var p=document.querySelector('.mn-panel[data-panel="'+tab+'"]');
        if(p)p.classList.add('active');
      });
    });

    /* Expose */
    window.peMenu={v:6};
    window.openCart=openCart;window.closeCart=closeAll;
    window.openMobile=openMobile;window.closeMobile=closeAll;
    window.openSearch=openSearch;window.closeSearch=closeAll;
    window.closeAll=closeAll;

  })();
